import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOverview = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="M2.96 4.115a1 1 0 0 1 1-1h12.166a1 1 0 0 1 1 1v1.042a1 1 0 0 1-1 1H3.96a1 1 0 0 1-1-1zm0 5.07a1 1 0 0 1 1-1h5.083a1 1 0 0 1 1 1v1.042a1 1 0 0 1-1 1H3.96a1 1 0 0 1-1-1zm0 5.57a1.5 1.5 0 0 1 1.5-1.5h4.083a1.5 1.5 0 0 1 1.5 1.5v1.056a1.5 1.5 0 0 1-1.5 1.5H4.46a1.5 1.5 0 0 1-1.5-1.5zm9.107-5.07a1.5 1.5 0 0 1 1.5-1.5h2.06a1.5 1.5 0 0 1 1.5 1.5v6.126a1.5 1.5 0 0 1-1.5 1.5h-2.06a1.5 1.5 0 0 1-1.5-1.5z" />
  </svg>
);
export default SvgOverview;
